<template>
    <div class="new-members__flex">
        <div v-show="state === null">
            <team-request-control-accept @control-action="onControlAction" :request-id="requestId"></team-request-control-accept>
            <team-request-control-decline @control-action="onControlAction" :request-id="requestId"></team-request-control-decline>
        </div>
        <div v-if="state === 'loading'">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </div>
        <div v-else-if="state === 'accepted'">
            <p class="mb-0 text-center">
                <v-icon>mdi-check</v-icon> Přijat
            </p>
        </div>
        <div v-else-if="state === 'declined'">
            <p class="mb-0 text-center">
                <v-icon>mdi-cancel</v-icon> Odmítnut
            </p>
        </div>
    </div>
</template>

<script>
    import TeamRequestControlAccept from './TeamRequestControlAccept';
    import TeamRequestControlDecline from './TeamRequestControlDecline';

    export default {
        name: 'TeamRequestControl',
        components: {
            TeamRequestControlAccept,
            TeamRequestControlDecline,
        },
        props: {
            requestId: {
                type: String,
                required: true,
            },
        },
        data () {
            return {
                state: null,
            };
        },
        methods: {
            onControlAction ({ state }) {
                this.state = state;
            },
        },
    }
</script>
